module.exports = ".row{\r\n    padding:20px 0px 0px;\r\n}\r\n\r\n.row:nth-child(odd){\r\n    background:white;\r\n}\r\n\r\n@media print {\r\n  #print-section {\r\n    width: 100% !important;\r\n    max-width: 100% !important;\r\n  }\r\n  .paginate,\r\n  pagination-controls {\r\n    display: none !important;\r\n  }\r\n\r\n  body {\r\n    -webkit-print-color-adjust: exact;\r\n    print-color-adjust: exact;\r\n  }\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/applicant/installment-payment/installment-payment-form/installment-payment-form.component.css
// module id = ./src/app/applicant/installment-payment/installment-payment-form/installment-payment-form.component.css
// module chunks = main